// src/services/electrospinningService.js
import { endpoints } from '../api/endpoints';
import axios from "axios";

export async function downloadDatasetExcel() {
    try {
        const response = await fetch(endpoints.downloadExcel, {
            method: 'GET',
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to download Excel: ${response.statusText}`);
        }

        const contentType = response.headers.get('Content-Type');
        if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            return await response.blob();
        } else {
            const text = await response.text();
            throw new Error(`Unexpected content: ${text}`);
        }

    } catch (error) {
        console.error(`[Download Excel] ${error.message}`);
        throw error;
    }
}

// In-memory cache variable (cleared on browser refresh)
let masterDatasetCache = null;

export async function fetchAllDatasetJson(forceRefresh = false) {
    if (forceRefresh) {
        masterDatasetCache = null;
    }

    if (!forceRefresh) {
        const cached = masterDatasetCache;
        if (cached) {
            return cached;
        }
    }

    try {
        const response = await axios.get(endpoints.AllDatasetJson);
        const raw = response.data || [];

        // Update in-memory cache
        masterDatasetCache = raw;

        return raw;
    } catch (error) {
        console.error('[fetchDataset]', error);
        throw error;
    }
}

export async function fetchDownloadCount() {
    try {
        const response = await axios.get(endpoints.downloadCount);
        return response.data;
    } catch (error) {
        console.error('[fetchDownloadCount]', error);
        return null; // Return null instead of error to avoid breaking UI
    }
}

export async function logDatasetView() {
    try {
        await axios.post(endpoints.analyticsView);
    } catch (error) {
        console.error('[logDatasetView] Failed to log view', error);
    }
}

export async function fetchDatasetStats() {
    try {
        const response = await axios.get(endpoints.analyticsStats);
        return response.data; // Expected { views: number, downloads: number }
    } catch (error) {
        console.error('[fetchDatasetStats]', error);
        return { views: 0, downloads: 0 };
    }
}

export async function fetchDatasetVersions() {
    try {
        const response = await axios.get(endpoints.listVersions);
        return response.data || [];
    } catch (error) {
        console.error('[fetchDatasetVersions]', error);
        return [];
    }
}